export const OverlayFunctionTranslationJP = {
  OverlayFunction: {
    Source: {
      overlay_source: '任意オーバーレイ名',
    },
    Title: {
      list_head_title: '任意オーバーレイ一覧',
      detail_head_title: '任意オーバーレイ詳細',
    },
    Button: {
      detail: '詳細',
      delete: '削除',
      add_new: '新規追加',
      target_menu: '対象メニュー',
      restore: '復元',
      save: '保存',
    },
    Table: {
      selection: '選択',
      name: '任意オーバーレイ名',
      remarks: '備考',
      target_menu: '対象メニュー',
    },
    Warn: {
      warn_confirm_delete: '選択された任意オーバーレイを削除します。<br/>よろしいですか？',
      warn_confirm_no_delete:
        '選択された任意オーバーレイのうち({{name}})は、対象メニューが存在しているため削除できません。対象メニューを削除してから表示制御グループを削除してください。',
      warn_confirm_can_delete: 'それ以外の選択された任意オーバーレイを削除します。<br/>よろしいですか？',
      warn_confirm_restore: '選択された任意オーバーレイを復元します。<br/>よろしいですか？',
      warn_field_required: 'この項目は必須です',
      warn_number_required: '数値で入力してください',
      warn_integer: '整数で入力してください',
      warn_range: '0〜9の範囲で入力してください',
    },
    Form: {
      guide_description: '※案内は、日本語以外の言語を選択し、その言語が未設定の場合、英語が表示されます。',
      overlay_name: '任意オーバーレイ名',
      guide: '案内',
      japanese: '日本語',
      english: '英語',
      simplified_chinese: '中国語(簡体字)',
      free_group_lunch: '自由组合午餐',
      traditional_chinese: '中国語(繫体字)',
      korean: '韓国語',
      vietnamese: 'ベトナム語',
      remarks: '備考',
      hide_max_guest_count: '非表示にする最大来店人数（0=無効）',
    },
  },
};
